// Thin wrappers over the Telegram WebApp global. We deliberately avoid the
// official @telegram-apps/sdk-react package for now: its API surface evolves
// rapidly and we only need initData + ready/expand at this stage. Add the SDK
// back if/when we need MainButton, BackButton, haptics, etc.

export function getInitData(): string {
  if (import.meta.env.DEV && import.meta.env.VITE_DEV_INIT_DATA) {
    return import.meta.env.VITE_DEV_INIT_DATA
  }
  return window.Telegram?.WebApp?.initData ?? ''
}

export function readyTelegram(): void {
  const wa = window.Telegram?.WebApp
  if (!wa) return
  try {
    wa.ready()
    wa.expand()
  } catch {
    // SDK not available outside Telegram — ignore.
  }
}
